import { createSlice } from "@reduxjs/toolkit";

const statuses = {
  1: "Не подтверждена-NOT_CONFIRMED",
  2: "Подтверждена-CONFIRMED",
  3: "Отменена-CANCELED",
  4: "Проведена-COMPLETED"
};

const normalizeData = (data) =>
  data.map(
    ({ id, buyerId, countryIdFk, language, createdAt, dateFrom, status, buyerIdMeetingFk, order, zoomLink, languageId, unreadMessagesCount, exhibitionStand, exhibitionStandId }) => {
      const date = new Date(dateFrom);
      date.setHours(date.getHours() + 2);

      return {
        key: id,
        unreadMessagesCount,
        buyerId,
        exhibition: exhibitionStand && exhibitionStand.exhibition,
        countryId: buyerIdMeetingFk?.country?.name ?? "",
        product: order?.item ?? "",
        company: buyerIdMeetingFk?.companyName ?? "",
        fullName: `${buyerIdMeetingFk?.user?.firstName ?? ""
          } ${buyerIdMeetingFk?.user?.lastName ?? ""}`.trim(),
        country: buyerIdMeetingFk?.country?.localizedName ?? "",
        workMail: buyerIdMeetingFk?.user?.email ?? "",
        phoneNumber: buyerIdMeetingFk?.phone ?? "",
        productAmount: order?.itemAmount ?? "",
        message: order?.message ?? "",
        language: language ?? "",
        languageId: languageId ?? "",
        requestTime: createdAt ?? "",
        meetingTime: dateFrom ?? "",
        meetingDuration: date.toISOString(),
        link: zoomLink ?? "",
        toDialog: buyerId ?? "",
        status,
        exhibitionStandId
      };
    }
  );

const initialState = {
  data: [],
  total: 10
};

const incomingRequestsMeetingSellerSlice = createSlice({
  name: "incomingRequestsMeetingSeller",
  initialState,
  reducers: {
    setData(state, action) {
      state.total = action.payload.total;
      state.data = normalizeData(action.payload.items);
    }
  }
});

export const { setData } = incomingRequestsMeetingSellerSlice.actions;

export default incomingRequestsMeetingSellerSlice.reducer;